/* eslint-disable func-style */
const MainPage = () => import('@/pages/MainPage.vue');
const PrintDemo = () => import('@/pages/021907Demo.vue');

const MainRouter = [
	{ path: '/', name: 'MainPage', component: MainPage },
	{ path: '/MainPage', name: 'MainPage', component: MainPage },
	{ path: '/02197_001', name: '02197_001', component: PrintDemo },
];

export default MainRouter;
